<template>
  <div class="dispatch-form-extra" :class="{ 'is-compact': compact, 'is-stacked': stacked && !compact }">
    <el-row v-if="compact" :gutter="12" class="compact-row">
      <el-col v-if="showCycsts" :xs="24" :sm="8">
        <el-form-item label="采样预测天数" class="compact-item">
          <el-input-number
            :value="value.cycsts"
            :min="1"
            :max="365"
            controls-position="right"
            class="compact-input-num"
            :disabled="readonly"
            @input="patch('cycsts', $event)"
          />
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="showCycsts ? 8 : 12">
        <el-form-item label="交通工具" class="compact-item">
          <el-input
            :value="value.jtgj"
            placeholder="如：公司车辆"
            :disabled="readonly"
            @input="patch('jtgj', $event)"
          />
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="showCycsts ? 8 : 12">
        <el-form-item label="样品交接人员" class="compact-item">
          <el-select
            :value="value.ypjjry"
            filterable
            placeholder="默认同采样人"
            clearable
            style="width:100%"
            :disabled="readonly"
            @change="patch('ypjjry', $event)"
          >
            <el-option v-for="u in users" :key="'jj-' + u.id" :label="u.xm" :value="u.xm" />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <template v-else>
      <el-row :gutter="stacked ? 0 : 20">
        <el-col :span="stacked ? 24 : (showCycsts ? 12 : 24)">
          <el-form-item v-if="showCycsts" label="采样预测天数">
            <el-input-number
              :value="value.cycsts"
              :min="1"
              :max="365"
              style="width:100%"
              :disabled="readonly"
              @input="patch('cycsts', $event)"
            />
          </el-form-item>
        </el-col>
        <el-col :span="stacked ? 24 : (showCycsts ? 12 : 24)">
          <el-form-item label="交通工具">
            <el-input
              :value="value.jtgj"
              :disabled="readonly"
              @input="patch('jtgj', $event)"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="showHandoverTime" :gutter="20">
        <el-col :span="12">
          <el-form-item label="样品交接人员">
            <el-select
              :value="value.ypjjry"
              filterable
              placeholder="默认同采样人，可改"
              clearable
              style="width:100%"
              :disabled="readonly"
              @change="patch('ypjjry', $event)"
            >
              <el-option v-for="u in users" :key="'jj-' + u.id" :label="u.xm" :value="u.xm" />
            </el-select>
            <div v-if="!readonly" class="field-hint">回公司交样给综合办的人，通常与采样人员相同</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="交接时间">
            <el-date-picker
              :value="value.jjsj"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              style="width:100%"
              :disabled="readonly"
              @input="patch('jjsj', $event)"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-else :gutter="20">
        <el-col :span="24">
          <el-form-item label="样品交接人员">
            <el-select
              :value="value.ypjjry"
              filterable
              placeholder="默认同采样人，可改"
              clearable
              style="width:100%"
              :disabled="readonly"
              @change="patch('ypjjry', $event)"
            >
              <el-option v-for="u in users" :key="'jj-' + u.id" :label="u.xm" :value="u.xm" />
            </el-select>
            <div v-if="!readonly" class="field-hint">回公司交样给综合办的人，通常与采样人员相同</div>
          </el-form-item>
        </el-col>
      </el-row>
    </template>
    <template v-if="showSignatures">
      <el-divider />
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="派遣人（签名）">
            <SignUserPicker
              role-label=""
              :value="signValue('派遣人')"
              :mode="readonly ? 'view' : 'edit'"
              @change="onSignChange('派遣人', $event)"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="批准人（签名）">
            <SignUserPicker
              role-label=""
              :value="signValue('批准人')"
              :mode="readonly ? 'view' : 'edit'"
              @change="onSignChange('批准人', $event)"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="日期">
            <el-date-picker
              :value="value.rq"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              style="width:100%"
              :disabled="readonly"
              @input="patch('rq', $event)"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </template>
  </div>
</template>

<script>
import SignUserPicker from '@/components/SignUserPicker.vue'
import { readSignValue, writeSignValue } from '@/utils/user'

export default {
  name: 'DispatchFormExtra',
  components: { SignUserPicker },
  props: {
    value: { type: Object, default: () => ({}) },
    users: { type: Array, default: () => [] },
    readonly: { type: Boolean, default: false },
    showCycsts: { type: Boolean, default: true },
    showHandoverTime: { type: Boolean, default: false },
    showSignatures: { type: Boolean, default: true },
    stacked: { type: Boolean, default: false },
    compact: { type: Boolean, default: false }
  },
  methods: {
    patch(key, val) {
      this.$emit('input', { ...this.value, [key]: val })
    },
    signValue(role) {
      return readSignValue(this.value || {}, role)
    },
    onSignChange(role, sign) {
      this.$emit('input', writeSignValue(this.value || {}, role, sign))
    }
  }
}
</script>

<style scoped>
.field-hint { font-size: 12px; color: #909399; line-height: 1.4; margin-top: 4px; }

.dispatch-form-extra.is-compact >>> .compact-item {
  margin-bottom: 0;
}

.dispatch-form-extra.is-compact >>> .compact-item .el-form-item__label {
  font-size: 12px;
  line-height: 28px;
  padding-bottom: 0;
  color: #909399;
}

.dispatch-form-extra.is-compact >>> .compact-item .el-form-item__content {
  line-height: 28px;
}

.dispatch-form-extra.is-compact .compact-input-num {
  width: 100%;
}

.dispatch-form-extra.is-compact >>> .compact-input-num .el-input__inner {
  text-align: left;
}
</style>
